import { useEffect } from 'react';

export function useMotion(host, key) {
  useEffect(() => {
    const root = host.current;
    if (!root || !('IntersectionObserver' in window)) return;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    let observer;
    const start = () => {
      observer?.disconnect();
      if (reduced.matches) { root.getAnimations?.({ subtree: true }).forEach(a => a.cancel()); return; }
      observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        const el = entry.target;
        el.animate?.([{ opacity: .35, transform: 'translateY(18px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 540, delay: Number(el.dataset.motionDelay || 0), easing: 'cubic-bezier(.2,.7,.3,1)' });
        observer.unobserve(el);
      }), { threshold: .12 });
      root.querySelectorAll('.section-head,.product,.service-items article,.business-tools button,.contact-banner,.compare-tech article').forEach((el, i) => { el.dataset.motionDelay = (i % 3) * 55; observer.observe(el); });
    };
    start(); reduced.addEventListener?.('change', start);
    return () => { observer?.disconnect(); reduced.removeEventListener?.('change', start); root.getAnimations?.({ subtree: true }).forEach(a => a.cancel()); };
  }, [host, key]);
}